import { Route, Routes } from 'react-router-dom';
import { TRAVO_BASE } from '@/travo/i18n/locale';
import { MS_BASE } from '@/membersheep/i18n/paths';
import { SECTIONS } from './sections';

/**
 * One route per site section; each section (src/app/sections.tsx) is its own JS chunk with its
 * own routes, layout and 404. The Labs section takes `/` and every other unknown URL.
 */
export const AppRoutes = () => (
  <Routes>
    <Route path={`${TRAVO_BASE}/*`} element={<SECTIONS.travo.Section />} />
    <Route path={`${MS_BASE}/*`} element={<SECTIONS.memberSheep.Section />} />
    <Route path="*" element={<SECTIONS.labs.Section />} />
  </Routes>
);
